import "bootstrap/dist/css/bootstrap.min.css"; // Import Bootstrap CSS
import { createApp } from "vue";
import App from "./App.vue";
//import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import axios from "axios";
import "bootstrap"; // Optionally import Bootstrap JS (if needed)
import "@fortawesome/fontawesome-free/css/all.css"; // Import Font Awesome CSS
import "vue3-country-intl/lib/vue3-country-intl.css";
//import { CkeditorPlugin } from '@ckeditor/ckeditor5-vue'

axios.defaults.baseURL = "https://api.lagoslawntennisclub1895.com/api/v1";
//axios.defaults.baseURL = "http://localhost:8888/lltc_backend/api/v1";
axios.interceptors.request.use(
  (config) => {
    const dynamicToken = localStorage.getItem("wertyuiojhdfghhdrtfyguh");
    if (dynamicToken) {
      config.headers.Authorization = `Bearer ${dynamicToken}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

createApp(App).use(store).use(router).mount("#app");
